export default class HTTPError extends Error {
  constructor(httpStatus, ...params) {
    super(...params);
    this.httpStatus = httpStatus;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, HTTPError);
    }
  }
}
